import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import axios from '../../../../utils/config-axios';
import {CourseworkLocalStorageKeys,removeCourseworkSession} from "../coursework-utils";
import {validateEmail} from "../../../../utils/form-helper";

import Modal from 'react-bootstrap/Modal';
import ButtonAndSpinner2 from '../../../../components/UI/Buttons/ButtonAndSpinner2';

import classes from './CourseworkLoginModal.module.scss';
import * as errorHelper from "../../../../utils/error-helper";


const COURSEWORK_ERROR_MESSAGES = {
    ERROR_INVALID_EMAIL_FORMAT: "Check that your email is formatted correctly.",
};



/**
 * CHECKED-2024-2-COURSEWORK
 */
class CourseworkLoginModal extends Component {

    state = {

        submitInProgress:false,

        email:"",

        loginMessage:null,
    };



    componentDidUpdate(prevProps) {
        this.signoutCourseworkUser();
    }



    submitLogin = () => {

        if(this.state.submitInProgress){
            return;
        }

        if(!this.validateForm()){
            return;
        }

        const data = {
            code:this.props.courseworkCode,
            email: this.state.email,
        };

        this.setState({
            submitInProgress:true,
            loginMessage:null,
        });


        axios({
            url: '/api/public/coursework/login/submit',
            method: 'POST',
            data: data
        }).then(result => {

            // console.log("Coursework Login result",result);

            if(result.data.status!==1){

                throw new Error(result.data.message);
            }

            this.setState({
                submitInProgress:false,
                loginMessage:null,
            });

            //
            // Update localstorage to maintain session info.
            //
            localStorage.setItem(CourseworkLocalStorageKeys.AMI_COURSEWORK_CODE_KEY, result.data.code);
            localStorage.setItem(CourseworkLocalStorageKeys.AMI_COURSEWORK_USER_ID_KEY, result.data.coursework_user_id);
            localStorage.setItem(CourseworkLocalStorageKeys.AMI_COURSEWORK_USER_EMAIL_KEY, result.data.email);

            //
            // Go to course list screen.
            //
            this.props.history.push(`/coursework/list/${result.data.code}`)

        }).catch(error => {

            console.log("Coursework login error.", error);

            //
            // Display generic error.
            //
            this.setState({
                submitInProgress:false,
                loginMessage:errorHelper.DEFAULT_ERROR_MESSAGE_1,
            });

            this.signoutCourseworkUser();
        });
    }


    validateForm = () => {
        const valid = validateEmail(this.state.email);
        if(!valid){
            this.setState({
                loginMessage:COURSEWORK_ERROR_MESSAGES.ERROR_INVALID_EMAIL_FORMAT,
            });

            return false;
        }

        return true;
    }

    signoutCourseworkUser = () => {
        removeCourseworkSession();
    };


    closeModal = () => {

        this.setState({
            passwordHidden:true
        });

        this.props.hide();
    };



    fieldChangedHandler = (event) => {

        this.setState( {
            [event.target.name] : event.target.value,
            loginMessage:null,
        } );
    };


    onKeyDownHandler = (event) => {
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();

            this.submitLogin();
        }
    };



    render() {

        return (
            <Modal
                className={classes.loginModal}
                show={this.props.show}
                onHide={this.props.hide}
                backdrop="static"
                keyboard={false}
                centered
                size="md" >
                <Modal.Body>

                    <img className={classes.closeBtn}
                         onClick={this.closeModal}
                         alt="close"
                         src={require("../../../../assets/images/icons/ico-close.svg").default}/>

                    <h2 className={classes.title+" medium-brown text-center mb-0"}>Access Coursework</h2>

                    <p className={"p-regular text-center mt-4"}>
                        Please enter the email address you used
                        <br/>
                        when registering for this event.
                    </p>

                    <div className={"text-center para-2 error-color "+classes.login_message}>
                        {this.state.loginMessage}
                    </div>

                    <div className={"text-center mt-1"}>
                        <form>
                            <div className={classes.formControl}>
                                <input name="email"
                                       type="text"
                                       maxLength={50}
                                       placeholder={"Email..."}
                                       className={classes.inputText + " w-100"}
                                       value={this.state.email}
                                       onKeyDown={this.onKeyDownHandler}
                                       onChange={ (event)=>this.fieldChangedHandler(event,this)}/>
                            </div>
                        </form>

                        <ButtonAndSpinner2 className={classes.button+" mt-4 mb-4"}
                                          onClick={this.submitLogin}
                                          submitInProgress={this.state.submitInProgress}
                                          label1={"Submit"}
                                          label2={"Submit"}>
                        </ButtonAndSpinner2>

                    </div>

                </Modal.Body>
            </Modal>
        );
    }
}



export default withRouter(CourseworkLoginModal);
